import { render, staticRenderFns } from "./DiasLibres.vue?vue&type=template&id=706e3235&scoped=true"
import script from "./DiasLibres.vue?vue&type=script&lang=js"
export * from "./DiasLibres.vue?vue&type=script&lang=js"
import style0 from "./DiasLibres.vue?vue&type=style&index=0&id=706e3235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e3235",
  null
  
)

export default component.exports